
export const verifyRules = async (rules = [], id_unidad = null) => {

    let result = {
        id: 0,
        percent: 0,
        description: '' // `regla: validación general`
    }

    // check by unit
    const rule = rules.find(r => parseInt(r.id_unidad_negocio) === parseInt(id_unidad))
    if (rule) {
        result = {
            id: rule.id,
            percent: rule.rentabilidad_esperada,
            description: `regla: validación ${rule.nombre_tipo}`
        }
    }

    // check by general mode
    if (!rule) {
        const rule = rules.find(r => r.codigo_regla === 'general')
        if (rule) {
            result = {
                id: rule.id,
                percent: rule.rentabilidad_esperada,
                description: `regla: validación general`
            }
        }
    }

    return result

}

export const checkValidationStatus = async (mPresupuestado = 0, rules = []) => {

    const margenPresupuestado = parseFloat(parseFloat(mPresupuestado).toFixed(2))
    const margenOptimo = parseFloat(rules[0]?.rentabilidad_esperada || 0)
    const ruleId = rules[0]?.id || 0
    // console.log('margenPresupuestado, margenOptimo---', margenOptimo, margenPresupuestado)

    if (margenPresupuestado < margenOptimo) {
        return {
            validacion_estado: 'por validar',
            validacion_nota: '',
            validacion_rentabilidad_optima: margenOptimo,
            validacion_id_regla: ruleId
        }
    }

    return {
        validacion_estado: '',
        validacion_nota: '',
        validacion_rentabilidad_optima: 0,
        validacion_id_regla: 0,
    }

}